<template>
  <v-container fluid>
    <v-card tile>

      <v-card-title>
        Payments
        <v-spacer></v-spacer>
        <v-text-field
          dense
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
<!--        <v-divider class="mx-4" inset vertical></v-divider>-->
<!--        <v-btn @click="$router.push('/admin/reservation_items/new')" class="primary">New item</v-btn>-->
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :loading="loading"
        loading-text="Loading... Please wait"
      >

        <template v-slot:item.amount="{ item }">
          {{ `CZK ${item.amount}` }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon
            class="mr-2"
            color="blue"
            @click="editItem(item.id)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            color="red"
            @click="openDeleteItemDialog(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="deleteItemDialog"
      max-width="500px"
      transition="dialog-bottom-transition"
    >
      <v-card tile>
        <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteItemDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="deleteItem">Yes</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
export default {
  data () {
    return {
      path: 'payments',
      items: [],
      item: null,
      deleteItemDialog: false,
      loading: true,
      search: '',
      headers: [
        { text: 'DATE', value: 'date' },
        { text: 'AMOUNT', value: 'amount', width: '150px' },
        { text: 'ACCOUNT NUMBER', value: 'accountNumber' },
        { text: 'BANK CODE', value: 'bankCode' },
        { text: 'VARIABLE SYMBOL', value: 'variableSymbol' },
        { text: 'CONSTANT SYMBOL', value: 'constantSymbol' },
        { text: 'MESSAGE FOR RECIPIENT', value: 'messageForRecipient' },
        { text: 'NOTE', value: 'note' },
        { text: 'USER', value: '_user', width: '200px' },
        { text: 'ACTIONS', value: 'actions', sortable: false, width: '90px' }
      ]
    }
  },

  methods: {
    editItem (id) {
      this.$router.push(`/admin/${this.path}/edit?id=${id}`)
    },
    async fetchItems () {
      this.items = await this.$store.dispatch('rest/fetchAllItems', { path: this.path })

      // // Create currency formatter.
      // const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'CZK' })

      for (let i = 0; i < this.items.length; i++) {
        // this.items[i]._amount = formatter.format(this.items[i].amount)
        if (this.items[i].user) {
          this.items[i]._user = `[${this.items[i].user.id}] ${this.items[i].user.name} ${this.items[i].user.surname}`
        } else {
          this.items[i]._user = ''
        }
      }
    },
    async deleteItem () {
      await this.$store.dispatch('rest/deleteItem', {
        path: this.path,
        id: this.item.id
      })
      this.items.splice(this.items.indexOf(this.item), 1)
      this.item = null
      this.deleteItemDialog = false
    },
    openDeleteItemDialog (item) {
      this.item = item
      this.deleteItemDialog = true
    }
  },
  async mounted () {
    document.title = 'Payments | Masarka Student Club'
    this.loading = true
    await this.fetchItems()
    this.loading = false
  }
}
</script>

<style scoped>

</style>
